import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { captureException, init, replayIntegration, setTag } from '@sentry/angular';
import { filter, take } from 'rxjs';
import { BRAND_CONFIG } from 'brand';
import { FeatureFlagService } from 'feature-flag';
import { EnvironmentService } from 'utils';
import { release } from './release';

@Injectable({
  providedIn: 'root',
})
export class SentryService {
  private brand = inject(BRAND_CONFIG).brand;
  private environmentService = inject(EnvironmentService);
  private featureFlags = inject(FeatureFlagService);
  private platformId = inject(PLATFORM_ID);

  constructor() {
    if (isPlatformServer(this.platformId)) return;
    if (this.environmentService.isLocal()) return;
    this.featureFlags.ready.pipe(filter(Boolean), take(1)).subscribe(() => {
      if (!this.featureFlags.isOn('sentry')) return;
      this.initSentry();
    });
  }

  private initSentry() {
    const environment = this.environmentService.isProduction() ? 'production' : 'development';
    init({
      dsn: 'https://bff26e6b0038aa187257be4228159ff4@o4507967200690176.ingest.de.sentry.io/4507967201869904',
      integrations: [replayIntegration()],
      replaysOnErrorSampleRate: 1.0,
      environment: environment,
      release: release,
    });
    setTag('brand', this.brand);
  }

  captureException(error: unknown): void {
    captureException(error);
  }
}
